import React, { useEffect, useState, useContext } from "react";
import Logowhite from "../../assets/CreditAnalyse/img/logo-white.e7860257.png";
import Secureicon from "../../assets/CreditAnalyse/img/security-safe-svgrepo-com.svg";
import { useGetCreditAnalysisDataV2 } from "../../Hooks/useGetCreditAnalysisDataV2";
import { useHistory } from "react-router-dom";
import VisitorParamsContext from "../../Contexts/VisitorParams";
import ReferenceContext from "../../Contexts/ReferenceContext";
import GetVisitorsParams from "../../Utility/GetVisitorsParams";
import { usePageLoad } from "../../Hooks/usePageLoad";
import { getPageName } from "../../Constants/PageNames";
import { queryString } from "../../Utility/QueryString";
import "../../assets/CreditAnalyse/css/loaderOTP.scss";
import { Api } from "../../api/Api";
import LoaderFlp from "../Includes/Layouts/OTPflp/LoaderFlp";
import { useClaimReg } from "../../Hooks/useClaimReg";
import { useSkippedLeads } from "../../Hooks/useSkippedLeads";
import { useFollowupLoad } from "../../Hooks/useFollowupLoad";


const OTP_Flp = () => {


    const history = useHistory();
    const { loadFollowup } = useFollowupLoad();
    const { visitorParameters } = useContext(VisitorParamsContext);
    const { getCreditAnalysisDataV2 } = useGetCreditAnalysisDataV2();
    const { skippedLeads } = useSkippedLeads();
    const [formData,setFormData] = useState({});
    const { setReferenceID } = useContext(ReferenceContext);
    const { savePageLoad, calledOnce } = usePageLoad();
    const [uuid,setUUID] = useState("");
    const [splitName,setSplitName] = useState("");
    const [source,setSource] = useState("");
    const [showLoaderOTP, setShowLoaderOTP] = useState("hide");
    const [showLoad, setShowLoad] = useState("show");
    const [btnDisabled, setBtnDisabled] = useState(true);
    const { updateClaimReg } = useClaimReg();
    const [loader, setLoader] = useState(true);

    useEffect(() => {
        (async () => {
            const response = await Api.get(
                "/api/v1/followup/get-details-otp?query_string=" + queryString,
                {}
            );
            if (response.data.status === "Success") {
                let followupDetails = response.data.response.followup_data;
                localStorage.setItem('allFollowupData', JSON.stringify(followupDetails));
                setUUID(response.data.response.uuid);
                localStorage.setItem('uuid', response.data.response.uuid);
                let userId = response.data.response.user_id;
                let title = response.data.response.title;
                let txtFName = response.data.response.first_name;
                let txtLName = response.data.response.last_name;
                let txtMName = response.data.response.middle_name;
                let DobDay = response.data.response.dob_day;
                let DobMonth = response.data.response.dob_month;
                let DobYear = response.data.response.dob_yr;
                let txtPostCode = response.data.response.postcode;
                let txtHouseNumber = response.data.response.address_line1;
                let txtAddress2 = response.data.response.address_line2;
                let txtAddress3 = response.data.response.address_line3;
                let addressLine4 = response.data.response.address_line4;
                let txtTown = response.data.response.town;
                let country = response.data.response.country;
                let txtCounty = response.data.response.county;
                setSplitName(response.data.response.split_name);
                localStorage.setItem('split_name', response.data.response.split_name);
                setSource(response.data.response.source);
                let txtEmail = response.data.response.email;
                let txtPhone = response.data.response.phone;
                setFormData({
                    userId,
                    title,
                    txtFName,
                    txtLName,
                    txtMName,
                    DobDay,
                    DobMonth,
                    DobYear,
                    txtPostCode,
                    txtHouseNumber,
                    txtAddress2,
                    txtAddress3,
                    addressLine4,
                    txtTown,
                    country,
                    txtCounty,
                    split_name : response.data.response.split_name,
                    source : response.data.response.source,
                    txtEmail,
                    txtPhone,
                })
                // localStorage.setItem('formData', JSON.stringify(formData));
                const flpResponse = await loadFollowup(
                        "followup_load",
                        followupDetails,
                        "fos_cc_flp",
                        queryString,
                        "fos_cc_flp"
                        );

            }

        })();
        // setTimeout(() => {
        //     setShowLoad("hide");
        //     setShowLoaderOTP("show");
        // }, 5000); // Adjust the delay as needed


    }, []);

    const handleSubmit = async (e) => {
        setShowLoad("hide");
        setShowLoaderOTP("show");
        setBtnDisabled(true);
        const claimReg = await updateClaimReg(uuid, splitName, "FLP_OTP", source);

        if (uuid && formData) {
            const res = await getCreditAnalysisDataV2(
                uuid,
                formData,
                "send_otp"
            );
      
            if (res.data.status === "Success" && res?.data?.response?.vendor_response?.Info?.Data?.reference) {
                setReferenceID(res?.data?.response?.vendor_response?.Info?.Data?.reference);
            }

            if(res.data.status === "Success" && (res?.data?.response?.vendor_response?.Info?.Message === "Phone number assessed not to be high-risk" || res?.data?.response?.is_dupe === "yes")) {
                let type = '';
                if(res?.data?.response?.is_dupe === "yes") {
                    type = 'cc_duplicate';
                } else {
                    type = 'phone_assessment';
                }
                
            // if(res.data.status === "Success" && res?.data?.response?.vendor_response?.Info?.Message === "Phone number assessed not to be high-risk") {

                const skippedLeadsResponse = skippedLeads(
                    type,
                    (uuid),
                    splitName
                );

                history.push(
                    "/credit_check_confirm_flp?uuid=" +
                    uuid
                );
            } else {
            history.push(
                "/credit_check_fos_flp?uuid=" +
                uuid + 
                 "&" +
                queryString
  
            );
        }

        }
    }
    useEffect(() => {
        if (Object.keys(formData).length > 0) {
            localStorage.setItem('formData', JSON.stringify(formData));
        }
    }, [formData]);

    useEffect(() => {
        if (uuid) {
            setLoader(false);
            setBtnDisabled(false);         
        }
    }, [uuid]);



    useEffect(() => {
        if (!!uuid && !calledOnce) {
            const data = {
                uuid,
                page_name: getPageName("credit"),
                status: "visited",
                source: "regular",
            };
            (async () => {
                await savePageLoad(
                    visitorParameters.visitor_parameters,
                    data,
                    "visited_status",
                    splitName,
                    queryString,
                    visitorParameters.data
                );
            })();
        }
    }, [uuid, calledOnce]);

    return (
        <>
            <GetVisitorsParams />
            <LoaderFlp showLoad={showLoad} handleSubmit={handleSubmit} btnDisabled={btnDisabled} loader={loader} />
            <div className={`loaderOTP ${showLoaderOTP}`}>
                <div className="bg_preldr">
                    <div className="container" style={{ marginTop: "-150px" }}>
                        <div>
                            <div className="brand">
                                <div className="logo pt-3 text-center">
                                    <a href="">
                                        <img src={Logowhite} height={60} alt="" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="preloader">
                        <div className="box">
                            <div className="logo">
                                <img height={40} src={Secureicon} alt="" />
                            </div>
                        </div>
                        <div className="box" />
                        <div className="box" />
                        <div className="box" />
                        <div className="box" />
                    </div>
                </div>
            </div>

        </>
    )
}

export default OTP_Flp;